import React from 'react';

export default function Terms() {
  return (
    <div className="container py-4" style={{ minHeight: '60vh' }}>
      <h2 className="text-center fw-bold">Terms & Conditions</h2>
      <div className="mx-auto my-2" style={{ width: 120, height: 4, background: '#000', borderRadius: 4 }} />

      <p>
        Welcome to Madhu Sewing Machine ("we", "us", "our"). These Terms of Service ("Terms") govern your use of our website and services.
        By accessing or using our Site, you agree to be bound by these Terms and our Privacy Policy. If you do not agree, do not use the Site.<br />
        <h6 className="mt-3 fw-bold">This Website is owned by Madhu Sewing Machine sales And  service Center.</h6>  
      </p>  


      <h5 className="mt-3 fw-bold">Eligibility</h5>
      <p>You must be at least 18 years old (or the age of majority in your jurisdiction) to use the Site.</p>

      <h5 className="mt-3 fw-bold">User Accounts</h5>
      <p>Provide accurate information, keep credentials confidential, and notify us of unauthorized access. We may suspend accounts at our discretion.</p>

      <h5 className="mt-3 fw-bold">Return/Refund Eligibility</h5>
      <p>You will have to raise a request for Return/Refund within 7 days of delivery.</p>

      <h5 className="mt-3 fw-bold">Refund Policy</h5>
   <p> For approved refunds, we will credit the refundable amount into the source account within 5-7 business days</p>

      <h5 className="mt-3 fw-bold">Return Policy</h5>
      <p>For Approved returns, we will deliver the replacement product within 5-7 business days</p>

      <h5 className="mt-3 fw-bold">Third‑Party Links</h5>
      <p>Our Site may link to third‑party websites. We are not responsible for their content or practices.</p>

      <h5 className="mt-3 fw-bold">Disclaimer of Warranties</h5>
      <p>Services are provided "as is" and "as available" without warranties of any kind, to the extent permitted by law.</p>

      <h5 className="mt-3 fw-bold">Limitation of Liability</h5>
      <p>To the maximum extent permitted by law, we are not liable for indirect or consequential damages.</p>

      <h5 className="mt-3 fw-bold">Indemnification</h5>
      <p>You agree to indemnify and hold us harmless from claims arising from your use of the Site or breach of these Terms.</p>

      <h5 className="mt-3 fw-bold">Changes to Terms</h5>
      <p>We may update these Terms over time. Continued use after updates constitutes acceptance of the revised Terms.</p>

      <h5 className="mt-3 fw-bold">Governing Law</h5>
      <p>These Terms are governed by the laws of India.</p>

      <h5 className="mt-3 fw-bold">Shipping Policy</h5>
      <p>We deliver orders within 3 to 4 of confirmation.</p>
    </div>
  );
}


